import React, { ChangeEvent, ReactElement, useRef, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { Library } from "./Library";
import { LibraryService } from "./LibraryService";

interface IParams {
	onCreate: (library: Library) => void;
}

export const LibraryForm = (props: IParams): ReactElement => {
	const [library] = useState<Library>(new Library());
	const [submitting, setSubmitting] = useState(false);
	const nameRef = useRef<HTMLInputElement>(null);
	const libraryService = new LibraryService();

	const handleSubmit = async () => {
		if (!library.name.trim()) {
			nameRef.current?.focus();
			return;
		}
		setSubmitting(true);
		const lib = await libraryService.create(library);
		setSubmitting(false);
		props.onCreate(lib);
	};

	return (
		<>
			<h5 className="mb-3" style={{ fontWeight: 600 }}>
				<i className="fa fa-plus-circle" style={{ marginRight: 8, opacity: 0.6 }} />
				New Library
			</h5>
			<Form>
				<Row>
					<Col md={4}>
						<Form.Group>
							<Form.Label>Name</Form.Label>
							<Form.Control
								ref={nameRef}
								type="text"
								placeholder="e.g. Leadership Library"
								onChange={(event: ChangeEvent<HTMLInputElement>) => {
									library.name = event.target.value;
								}}
							/>
						</Form.Group>
					</Col>
					<Col md={2}>
						<Form.Group>
							<Form.Label>Code</Form.Label>
							<Form.Control
								type="text"
								placeholder="e.g. LL01"
								onChange={(event: ChangeEvent<HTMLInputElement>) => {
									library.code = event.target.value;
								}}
							/>
						</Form.Group>
					</Col>
					<Col md={2}>
						<Form.Group>
							<Form.Label>eLearning</Form.Label>
							<div style={{ paddingTop: "0.5rem" }}>
								<Form.Check
									type="checkbox"
									label="Is eLearning?"
									onChange={(event: ChangeEvent<HTMLInputElement>) => {
										library.isElearning = event.target.checked;
									}}
								/>
							</div>
						</Form.Group>
					</Col>
					<Col md={2} className="d-flex align-items-end">
						<Form.Group className="w-100">
							<Button
								onClick={handleSubmit}
								disabled={submitting}
								className="w-100"
							>
								{submitting ? (
									<>
										<i className="fa fa-spinner fa-spin" /> Creating...
									</>
								) : (
									"Create"
								)}
							</Button>
						</Form.Group>
					</Col>
				</Row>
			</Form>
		</>
	);
};
